import React from 'react';
import VipPreferredLogo from '../USDeposit/icons/logo-vip-preferred.png';
import SightlineLogo from '../USDeposit/icons/logo-play+.png';
import SkrillLogo from '../USDeposit/icons//logo-skrill.png';

export const WithdrawMethodIds = {
	VipPreferred: 2,
	Skrill: 4,
	Sightline: 5,
};

export const WithdrawMethods = {
	VipPreferred: { id: 2, name: 'ACH-CHECK', icon: <img src={VipPreferredLogo} alt="ACH" /> },
	Skrill: { id: 4, name: 'SKRILL', icon: <img src={SkrillLogo} alt="Skrill" /> },
	Sightline: { id: 5, name: 'Sightline', icon: <img src={SightlineLogo} alt="Play+" /> },
};

export const ConvertPaymentTypeToView = (paymentMethod: { id: number; name: string }) => {
	if (paymentMethod.id === WithdrawMethodIds.VipPreferred) return WithdrawMethods.VipPreferred;
	if (paymentMethod.id === WithdrawMethodIds.Sightline) return WithdrawMethods.Sightline;
	if (paymentMethod.id === WithdrawMethodIds.Skrill) return WithdrawMethods.Skrill;
	return WithdrawMethods.VipPreferred;
};
